export default "__VITE_ASSET__CG_2_ks5__"